import React from "react";

import { useTranslation } from "react-i18next";

import "../../css/admin/comments.scss";
import Button from "../button/Button";

import type { JSX } from "react";

export type CommentActionType = "block" | "unblock" | "valid" | "delete";

interface CommentActionsProps {
  comment: {
    user?: {
      block_comments?: boolean;
    };
    valid: boolean;
  };
  createAction: (type: CommentActionType) => void;
  userAbility?: boolean;
}

function CommentActions({
  comment,
  createAction,
  userAbility = false,
}: CommentActionsProps): JSX.Element {
  const { t } = useTranslation("editor-comments");

  const isUserBlocked = Boolean(comment.user?.block_comments);

  return (
    <div className="mb-5 flex justify-end gap-5" data-testid="CommentActions">
      {userAbility ? (
        <Button
          data-testid="CommentActions-blockButton"
          onClick={() => createAction(!isUserBlocked ? "block" : "unblock")}
          size="sm"
          type="button"
        >
          {t(!isUserBlocked ? "blockUser" : "unBlockUser")}
        </Button>
      ) : null}
      {!comment.valid && (
        <Button
          data-testid="CommentActions-validateButton"
          onClick={() => createAction("valid")}
          size="sm"
          type="button"
        >
          {t("validateComment")}
        </Button>
      )}
      <Button
        data-testid="CommentActions-deleteButton"
        onClick={() => createAction("delete")}
        size="sm"
        type="button"
      >
        {t("deleteComment")}
      </Button>
    </div>
  );
}

export default CommentActions;
